// extracted by mini-css-extract-plugin
export var bottomLabel = "PricesFrom-module--bottom-label--c638a";
export var disclaimer = "PricesFrom-module--disclaimer--ba656";
export var singlePrice = "PricesFrom-module--single-price--42bb7";